import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import {
  NbListModule,
  NbActionsModule,
  NbButtonModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbSelectModule,
  NbCardModule,
  NbUserModule,
  NbDatepickerModule,
  NbCheckboxModule,
  NbToggleModule,
  NbTooltipModule,
  NbProgressBarModule,
  NbAlertModule,
  NbStepperModule,
  NbRadioModule
} from "@nebular/theme";
  
import { FormsModule } from "@angular/forms";
import { SingleNumberComponent } from "./statistics/single-number/single-number.component";
import { ChartComponent } from "./statistics/chart/chart.component";
import { UsersTableComponent } from "./users-table/users-table.component";
import { UserRowComponent } from "./users-table/user-row/user-row.component";
import { UserEditComponent } from "./user-edit/user-edit.component";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { UserCreateComponent } from "./user-create/user-create.component";
import { ConfirmDialogComponent } from "./utils/confirm-dialog/confirm-dialog.component";
import { PlanUpgradeComponent } from "./plan-upgrade/plan-upgrade.component";
import { InvoicesComponent } from "./invoices/invoices.component";
import { EmailTableComponent } from "./email-table/email-table.component";
import { EmailRowComponent } from "./email-table/email-row/email-row.component";
import { EmailNewComponent } from "./email-new/email-new.component";
import { EmailEditorModule } from "angular-email-editor";
import { FormsTableComponent } from "./forms/forms-table/forms-table.component";
import { FormRowComponent } from "./forms/forms-table/form-row/form-row.component";
import { FormNewComponent } from "./forms/form-new/form-new.component";
import { ColorPickerModule } from "ngx-color-picker";
import { FormFieldComponent } from "./forms/form-field/form-field.component";
import { SnippetComponent } from "./forms/snippet/snippet.component";

import { FlussiTableComponent } from "./flusso/flusso-table/flusso-table.component";

import { ProjectCampaignsTableComponent } from "./projects-campaigns/projects-campaigns-table/projects-campaigns-table.component";
import { ProjectsCampaignNewComponent } from "./projects-campaigns/projects-campaign-new/projects-campaign-new.component";
import { ProjectsCampaignRowComponent } from "./projects-campaigns/projects-campaigns-table/projects-campaign-row/projects-campaign-row.component";
import { ProjectsCampaignStatisticsComponent } from "./projects-campaigns/projects-campaign-statistics/projects-campaign-statistics.component";
import { ProjectsCampaignExportComponent } from "./projects-campaigns/projects-campaign-export/projects-campaign-export.component";

import { ProjectsLeadsTableComponent } from "./projects-leads/projects-leads-table.component";
import { ProjectsLeadsRowComponent } from "./projects-leads/projects-leads-row/projects-leads-row.component";

import { FinanceCampaignsTableComponent } from "./finance-campaigns/finance-campaigns-table/finance-campaigns-table.component";
import { FinanceCampaignNewComponent } from "./finance-campaigns/finance-campaign-new/finance-campaign-new.component";
import { FinanceCampaignRowComponent } from "./finance-campaigns/finance-campaigns-table/finance-campaign-row/finance-campaign-row.component";
import { FinanceCampaignStatisticsComponent } from "./finance-campaigns/finance-campaign-statistics/finance-campaign-statistics.component";
import { FinanceCampaignExportComponent } from "./finance-campaigns/finance-campaign-export/finance-campaign-export.component";

import { FinanceLeadsTableComponent } from "./finance-leads/finance-leads-table.component";
import { FinanceLeadsRowComponent } from "./finance-leads/finance-leads-row/finance-leads-row.component";

import { AlertsTableComponent } from './alerts/alerts-table/alerts-table.component';
import { AlertRowComponent } from './alerts/alerts-table/alert-row/alert-row.component';
import { AlertNewComponent } from './alerts/alert-new/alert-new.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationRowComponent } from './notifications/notification-row/notification-row.component';
import { OfferNewComponent } from './offers/offer-new/offer-new.component';
import { OfferTableComponent } from './offers/offer-table/offer-table.component';
import { OfferRowComponent } from './offers/offer-table/offer-row/offer-row.component';
import { FlussoRowComponent } from "./flusso/flusso-table/flusso-row/flusso-row.component";
import { FlussoNewComponent } from "./flusso/flusso-new/flusso-new.component";
import { FlussoFieldComponent } from "./flusso/flusso-field/flusso-field.component";
import { ChatRowComponent } from "./chat/chat-table/chat-row/chat-row.component";
import { ChatNewComponent } from "./chat/chat-new/chat-new.component";
import { ChatFieldComponent } from "./chat/chat-field/chat-field.component";
import { ChatsTableComponent } from "./chat/chat-table/chat-table.component";


const NbModules = [
  NbStepperModule,
  NbToggleModule,
  NbAlertModule,
  NbCheckboxModule,
  NbListModule,
  NbActionsModule,
  NbButtonModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbSelectModule,
  NbCardModule,
  NbUserModule,
  NbDatepickerModule,
  NbTooltipModule,
  NbProgressBarModule,
  NbRadioModule
];

@NgModule({
  declarations: [
    SingleNumberComponent,
    ChartComponent,
    UsersTableComponent,
    UserRowComponent,
    UserEditComponent,
    UserCreateComponent,
    ConfirmDialogComponent,
    PlanUpgradeComponent,
    InvoicesComponent,
    EmailTableComponent,
    EmailRowComponent,
    EmailNewComponent,
    FormsTableComponent,
    FormRowComponent,
    FormNewComponent,
    FormFieldComponent,
    SnippetComponent,

    ProjectCampaignsTableComponent,
    ProjectsCampaignNewComponent,
    ProjectsCampaignRowComponent,
    ProjectsCampaignStatisticsComponent,
    ProjectsCampaignExportComponent,

    ProjectsLeadsTableComponent,
    ProjectsLeadsRowComponent,


    FinanceCampaignsTableComponent,
    FinanceCampaignNewComponent,
    FinanceCampaignRowComponent,
    FinanceCampaignStatisticsComponent,
    FinanceCampaignExportComponent,
    
    FinanceLeadsTableComponent,
    FinanceLeadsRowComponent,
    
    AlertsTableComponent,
    AlertRowComponent,
    AlertNewComponent,
    NotificationsComponent,
    NotificationRowComponent,
    OfferNewComponent,
    OfferTableComponent,
    OfferRowComponent,
    FlussiTableComponent,
    FlussoRowComponent,
    FlussoNewComponent,
    FlussoFieldComponent,
    ChatRowComponent,
    ChatNewComponent,
    ChatFieldComponent,
    ChatsTableComponent
  ],
  imports: [
    EmailEditorModule,
    AngularFireStorageModule,
    NgxChartsModule,
    CommonModule,
    FormsModule,
    ColorPickerModule,
    ...NbModules,
  ],
  exports: [
    InvoicesComponent,
    PlanUpgradeComponent,
    SingleNumberComponent,
    ChartComponent,
    UsersTableComponent,
    UserRowComponent,
    UserEditComponent,
    UserCreateComponent,
    ConfirmDialogComponent,
    EmailTableComponent,
    FormsTableComponent,
    ProjectCampaignsTableComponent,
    FinanceCampaignsTableComponent,
    AlertsTableComponent,
    NotificationsComponent,
    OfferTableComponent,
    FlussiTableComponent,
    FlussoRowComponent,
    ChatsTableComponent,
    ProjectsLeadsTableComponent,
    FinanceLeadsTableComponent
  ],
  entryComponents: [
    UserCreateComponent,
    ConfirmDialogComponent,
    SnippetComponent,
    NotificationsComponent
  ],
})
export class componentsModule {}
